package floris.graphics.backoffice.components

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.functions.calc
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.silk.components.text.SpanTextStyle
import com.varabyte.kobweb.silk.style.addVariant
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.vw

val H4SpanTextVariant = SpanTextStyle.addVariant {
    base {
        Modifier
            .fontSize(calc { (0.3).vw + 1.275.cssRem.asDynamic() })
            .fontWeight(FontWeight.Medium)
    }
}
